import { useMemo } from 'react';
import { Chart, PieChartData } from '@frontend/charts';
import { i18next } from '@frontend/i18n';
import { formatters } from '@frontend/shared';
import { theme } from '@frontend/theme';
import { useGetPractitionerMetric } from './hooks/use-get-practitioner-metric';

const labels = {
  hygiene: i18next.t('Hygiene', { ns: 'analytics' }),
  restorative: i18next.t('Restorative', { ns: 'analytics' }),
};

const colors = {
  hygiene: theme.colors.warning50,
  restorative: theme.colors.secondary.eggplant30,
  skipTipRemaining: theme.colors.neutral20,
};

export const PractitionerAnalysisProductionValueChart = () => {
  const { aggregatedPractitionerAnalysisData, isLoading } = useGetPractitionerMetric();

  const chartData: PieChartData = useMemo(() => {
    if (!aggregatedPractitionerAnalysisData) {
      return {
        groups: [],
      };
    }

    const { hygieneTreatmentPlan, restorativeTreatmentPlan } = aggregatedPractitionerAnalysisData;

    return {
      centerMetric: `$${formatters.shortenNumber(
        hygieneTreatmentPlan.totals.unscheduledTreatment + restorativeTreatmentPlan.totals.unscheduledTreatment
      )}`,
      groups: [
        {
          name: 'hygiene',
          value: hygieneTreatmentPlan.totals.unscheduledTreatment,
        },
        {
          name: 'restorative',
          value: restorativeTreatmentPlan.totals.unscheduledTreatment,
        },
      ],
    };
  }, [aggregatedPractitionerAnalysisData]);

  return (
    <Chart colors={colors} isLoading={isLoading} labels={labels}>
      <Chart.PieChart
        appearance={{
          hideTooltip: true,
          minWidth: 240,
        }}
        data={chartData}
        formatValue={(value) => formatters.shortenCurrency(value)}
      />
      <Chart.Legends
        values={{
          hygiene: formatters.shortenCurrency(
            aggregatedPractitionerAnalysisData?.hygieneTreatmentPlan?.totals?.unscheduledTreatment
          ),
          restorative: formatters.shortenCurrency(
            aggregatedPractitionerAnalysisData?.restorativeTreatmentPlan?.totals?.unscheduledTreatment
          ),
        }}
      />
    </Chart>
  );
};
